<template>
  <div>
    <AppDialog
      class="time-off-policies-wizard"
      data-testid="edit-time-off-policy-modal"
      :title="viewMode ? 'View time off policy' : 'Edit time off policy'"
      :show="showDialog || loadingPolicy"
      :loading="loadingPolicy"
      append-to-body
      :position="dialogPosition"
      @close="closeDialogs"
    >
      <ValidationObserver ref="dialogObserver">
        <ValidationObserver ref="TimeOffPolicySetupFormObserver">
          <component
            :is="monthlyAccrualEnabled ? 'TimeOffPolicySetupFormV2' : 'TimeOffPolicySetupForm'"
            v-if="showDialog"
            :time-off-policy="timeOffPolicy"
            :org-time-zone="orgTimeZone"
            :dropdown-options="dropdownOptions"
            :show-dialog="showDialog"
            :editing="editing"
            :view-mode="viewMode"
          />
        </ValidationObserver>
      </ValidationObserver>
      <template #footer>
        <AppButton
          class="cancel"
          @click="closeDialogs"
        >
          {{ viewMode ? 'Close' : 'Cancel' }}
        </AppButton>
        <AppButton
          v-if="!viewMode"
          type="primary"
          data-testid="update-time-off-policy-button"
          :disabled="saving"
          @click="save"
        >
          Save
        </AppButton>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import TimeOffPolicyMixin from '~/mixins/time_off_policies/TimeOffPolicyMixin';
import TimeOffPolicySetupForm from '~/components/time_off_policies/TimeOffPolicySetupForm.vue';
import TimeOffPolicySetupFormV2 from '~/components/time_off_policies/TimeOffPolicySetupFormV2.vue';

export default {
  name: 'TimeOffPolicyEdit',
  components: {
    TimeOffPolicySetupForm,
    TimeOffPolicySetupFormV2,
  },
  mixins: [TimeOffPolicyMixin],
  computed: {
    dialogPosition() {
      return this.monthlyAccrualEnabled ? 'top' : 'centered';
    },
  },
};
</script>
